













import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import { URL } from '@/util/url'
import ShareBase from './ShareBase.vue'

@Component({
  components: {
    ShareBase,
  },
})
export default class ShareTwitter extends Vue {

  @Prop({ required: true })
  url: string

  @Prop({ required: true })
  text: string

  @Prop({ required: true })
  hashtags: string

  get urlOnShare(): string {
    const merged = URL.merge(this.url).with(this.gaparam)

    return encodeURIComponent(merged)
  }

  get gaparam(): string {
    return '?m=tw_share&utm_source=twitter&utm_medium=social&utm_campaign=item_share'
  }
}
